// @flow
import React from 'react';
import { View, StyleSheet, useWindowDimensions } from 'react-native';
import { WHITE_COLOR } from '../styles/common';
import Footer from './Footer/Footer';

const styles = StyleSheet.create({
    main_wrapper: {
        marginTop: 90,
        paddingHorizontal: '6%',
        paddingVertical: '3%',
        paddingTop: 110,
        backgroundColor: WHITE_COLOR,
    },
    main_wrapper_phone: {
        paddingHorizontal: 15,
        marginTop: 90,
        paddingVertical: '3%',
        backgroundColor: WHITE_COLOR,
    },
    pageWrapper: {
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'space-between',
        backgroundColor: WHITE_COLOR,
    },
});

type Props = {
    children: any
}

const MainWrapper = (props: Props) => {
    const { width } = useWindowDimensions();
    const { children } = props;
    return (
        <View style={styles.pageWrapper}>
            <View style={width > 600 ? styles.main_wrapper : styles.main_wrapper_phone}>
                {children}
            </View>
            <Footer />
        </View>
    );
};

export default MainWrapper;
